import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mobileShowFrindly'
})
export class MobileShowFrindlyPipe implements PipeTransform {

  transform(value: any): string {
    if (value==null || value.length != 11) return value;
    return `${value.substr(0, 4)} ${value.substr(4, 3)} ${value.substr(7, 4)}`
  }

}
